import axios, { getVariable } from "./api";
import { keycloak } from "../components/auth";

export const getUserSession = async () => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.get(
    (await getVariable("CONHECIGAME_API")) + "/v1/usuario/logado",
    headers
  );
};

export const findStatistic = async () => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.get(
    (await getVariable("CONHECIGAME_API")) + "/v1/usuario/estastistica",
    headers
  );
};

export const findStatisticMultiplayer = async () => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.get(
    (await getVariable("CONHECIGAME_API")) + "/v1/usuario/estastistica-multiplayer",
    headers
  );
};
